// Single source of truth for getting a valid Cognito access token.
// Delegates to Amplify v6, which handles storage + refresh for both
// Cognito-native users and federated (Google) users uniformly.
//
// Why not read tokens out of localStorage directly? amazon-cognito-identity-js
// only knows about user-pool-native sessions, so its userPool.getCurrentUser()
// returns null for Hosted UI / Google sign-ins and refresh fails. Amplify's
// fetchAuthSession works for both flows.
import { fetchAuthSession, signOut } from 'aws-amplify/auth';

export async function getAccessToken({ forceRefresh = false } = {}) {
  try {
    const session = await fetchAuthSession({ forceRefresh });
    return session.tokens?.accessToken?.toString() ?? null;
  } catch {
    return null;
  }
}

export async function getIdTokenPayload() {
  try {
    const session = await fetchAuthSession();
    return session.tokens?.idToken?.payload ?? null;
  } catch {
    return null;
  }
}

// Used when an API call returns 401 even after a forced refresh — the
// session is unrecoverable and the user has to sign in again.
export async function hardSignOut() {
  try {
    await signOut();
  } catch {
    // best-effort
  }
}
